/**
 * Shopify customer-facing domain normalisation.
 *
 * AM Decor's public Shopify store is exposed under our own domain:
 *   https://shop.amdecorsignsandprints.co.uk
 *
 * However, the backend (and sometimes Shopify itself) may return customer-facing
 * URLs on the internal *.myshopify.com domains. Any URL returned to the browser
 * for a checkout, cart, or product page MUST be rewritten to our public domain
 * so customers never see or hit a myshopify.com URL.
 *
 * Covered internal hostnames:
 *   - srbt1r-qn.myshopify.com         (current internal shop)
 *   - amdecorsign-prints.myshopify.com (legacy internal shop)
 */

export const PUBLIC_SHOPIFY_DOMAIN = "shop.amdecorsignsandprints.co.uk";

const INTERNAL_HOSTS = [
  "srbt1r-qn.myshopify.com",
  "amdecorsign-prints.myshopify.com",
];

/**
 * Normalise a customer-facing Shopify URL so it always uses our public domain.
 * Returns the input unchanged if it isn't a recognised internal Shopify URL.
 *
 * Safe for:
 *   - absolute URLs (http/https)
 *   - strings without a scheme (returned as-is)
 *   - null / undefined / empty (returned as-is)
 */
export function normaliseShopifyCustomerUrl(url) {
  if (!url || typeof url !== "string") return url;
  try {
    const u = new URL(url);
    if (INTERNAL_HOSTS.includes(u.hostname.toLowerCase())) {
      u.hostname = PUBLIC_SHOPIFY_DOMAIN;
      u.protocol = "https:";
      return u.toString();
    }
    return url;
  } catch {
    // Not a parseable absolute URL — leave it alone
    return url;
  }
}
